import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.string.repeat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-04-29 12:08:07
 * @LastEditors  : 程哲林
 * @LastEditTime : 2023-10-19 16:50:59
 * @FilePath     : /marketing-landing-fe/src/utils/index.ts
 * @Description  : 未添加文件描述
 */
// import * as Sentry from '@sentry/browser';


import { customError } from '@woulsl/sentry-config'; // import wx from 'jweixin-sdk-official';

import Cookie from 'js-cookie';
import QS from 'qs';
import { addTeacherPath, CUSTOMER_SERVICE_CENTER_ADDRESS, CUSTOMER_TRANSFORM, DEBUG_LOCAL, ENV_BASE, isJoJoUp, LOCAL_BASE_URL } from '@/const'; // 定义 32 进制的字符集

var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUV'; // 定义一个函数，接受一个十进制数字作为参数，返回一个 32 进制的字符串

export function decToBase32(dec) {
  var ndec = typeof dec === 'number' ? dec : parseInt(dec, 10); // 定义一个空字符串用于存放结果

  var result = ''; // 循环除以 32，直到商为 0

  while (ndec > 0) {
    // 取余数作为索引，从字符集中获取对应的字符，并拼接到结果字符串的前面
    result = chars[ndec % 32] + result; // 更新商为下一次循环的被除数

    ndec = Math.floor(ndec / 32);
  } // 返回结果字符串


  return result;
} // 定义一个函数，接受一个 32 进制的字符串作为参数，返回一个十进制的数字

export function base32ToDec(base32) {
  if (!base32 || /^1\d{10}$/.test(base32)) {
    return base32;
  } // 定义一个变量用于存放结果，初始值为 0


  var result = 0; // 循环遍历字符串中的每个字符

  for (var i = 0; i < base32.length; i++) {
    // 获取当前字符在字符集中的索引，作为当前位的权值
    var value = chars.indexOf(base32[i]); // 将权值乘以对应的进制数（32 的幂次），并累加到结果变量中

    result += value * Math.pow(32, base32.length - i - 1);
  } // 返回结果变量


  return result.toString();
}
export function maskNumber(number) {
  // 检查输入是否是数字，如果不是，抛出错误
  if (!/^\d+$/.test(number)) {
    throw new Error('Invalid number');
  } // 计算中间4/11的位置和长度


  var start = Math.floor(number.length / 11 * 3);
  var end = Math.ceil(number.length / 11 * 7);
  var length = end - start; // 使用字符串切片和拼接，将中间4/11的数字替换成*

  return number.slice(0, start) + '*'.repeat(length) + number.slice(end);
}
export function isElementInViewport(el) {
  if (!(el === null || el === void 0 ? void 0 : el.offsetParent)) {
    return false;
  } // 获取元素在文档中的位置


  var rect = el.getBoundingClientRect(); // 获取当前视口的尺寸

  var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  var right = typeof rect.right === 'number' ? Math.floor(rect.right) : rect.right; // 判断元素是否在视口内

  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= viewportHeight && right <= viewportWidth;
}
export var getPlatformSimple = function getPlatformSimple() {
  try {
    var isMiniApp = isWXMiniAppBrowser();
    var isWeChat = isWXBrowser();

    if (isMiniApp && isWeChat) {
      return '微信小程序';
    } else if (isMiniApp) {
      return '小程序内';
    } else if (isJoJoBrowser()) {
      return 'APP内';
    } else if (isWeChat) {
      return '微信内';
    }

    return '其他';
  } catch (e) {
    return '其他';
  }
};

var CustomError = function (_super) {
  __extends(CustomError, _super);

  function CustomError(_a) {
    var name = _a.name,
        message = _a.message;

    var _this = _super.call(this) || this;

    _this.name = name || 'customError';
    _this.message = message || 'customErrorMessage';
    return _this;
  }

  return CustomError;
}(Error);

export { CustomError };
/**
 * 错误上报
 * @param err 错误
 */

export function reportError(error) {
  if (error === void 0) {
    error = {};
  }
  /*  console.error(error);
  const exception = error.message || error.originalError || error.error || error;
  Sentry.captureException(exception); */


  customError(error);
}
/**
 * 检测浏览器环境是否是jojo app
 * eg：
 */

export var isJoJoBrowser = function isJoJoBrowser() {
  var ua = window.navigator.userAgent;
  var reg = /JoJoVersion|JoJoWebViewSymbol/i; // 排除一些老版本
  // const excludeReg = /huihua/gim;

  return reg.test(ua);
};
/**
 * 检测浏览器环境是否是识字app且是安卓设备
 * eg：
 */

export var isSherlockBrowser = function isSherlockBrowser() {
  var ua = window.navigator.userAgent;
  var reg = /JoJoVersion|JoJoWebViewSymbol/i;
  var includeReg = /sherlock/gim;
  return reg.test(ua) && includeReg.test(ua);
};
/**
 * 检测浏览器环境是否是绘本app且是安卓设备
 * eg：
 */

export var isHuibenAndroidBrowser = function isHuibenAndroidBrowser() {
  var ua = window.navigator.userAgent;
  var reg = /JoJoVersion|JoJoWebViewSymbol/i;
  var includeReg = /huiben/gim;
  var isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  return reg.test(ua) && includeReg.test(ua) && !isIOS;
};
/**
 * 检测浏览器环境是否是jojo阅读 app
 * eg：
 */

export var isJoJoReadBrowser = function isJoJoReadBrowser() {
  var ua = window.navigator.userAgent;
  var reg = /JoJoAppFrom\/read/i;
  return isJoJoBrowser() && reg.test(ua);
};
/**
 * 检测浏览器环境是否是jojoup app
 * eg：
 */

export var isJoJoUpBrowser = function isJoJoUpBrowser() {
  var ua = window.navigator.userAgent;
  var reg = /JoJoAppFrom\/flawless/i;
  return isJoJoBrowser() && reg.test(ua);
}; // 绘本/口算/识字

export var isNotJoJoReadBrowser = function isNotJoJoReadBrowser() {
  return !isJoJoReadBrowser();
};
/**
 * 检测浏览器环境是否是微信
 * eg：
 */

export var isWXBrowser = function isWXBrowser() {
  var ua = window.navigator.userAgent;
  var reg = /MicroMessenger/i;
  return reg.test(ua) && !isWXComBrowser();
};
/**
 * 检测浏览器环境是否是微信企业版
 * eg：
 */

export var isWXComBrowser = function isWXComBrowser() {
  var isComWx = /wxwork/i.test(navigator.userAgent);
  return isComWx;
};
/**
 * 只是微信app内嵌浏览器，非小程序或其他浏览器
 * @returns {boolean|boolean}
 */

export var isWXAppBrowser = function isWXAppBrowser() {
  var ua = window.navigator.userAgent;
  var reg = /miniprogram/i;
  return !reg.test(ua) && isWXBrowser();
};
/**
 * 微信小程序内嵌浏览器
 * @returns {boolean|boolean}
 */

export var isWXMiniAppBrowser = function isWXMiniAppBrowser() {
  var ua = window.navigator.userAgent;

  if (/alipay/gim.test(ua)) {
    return false;
  }

  var reg = /miniprogram/i;
  return reg.test(ua);
};
/**
 * 检测浏览器环境是否是抖音
 * eg：
 */

export var isTikTok = function isTikTok() {
  var ua = window.navigator.userAgent;
  var reg = /aweme/i;
  return reg.test(ua);
};
/**
 * 检测浏览器环境是否是快手
 * eg：
 */

export var isKuaiShou = function isKuaiShou() {
  var ua = window.navigator.userAgent;
  var reg = /kwai/i;
  return reg.test(ua);
};
/**
 * 检测浏览器环境是否是百度app
 * eg：
 */

export var isBaiduBoxApp = function isBaiduBoxApp() {
  var ua = window.navigator.userAgent;
  var reg = /baiduboxapp/i;
  return reg.test(ua);
};
/**
 * 检测浏览器环境是否为小程序webview
 * eg：
 */

export var getIsMiniProgramEnv = function getIsMiniProgramEnv() {
  return __awaiter(void 0, void 0, void 0, function () {
    var isWx, userAgent;
    return __generator(this, function (_a) {
      isWx = isWXBrowser();
      userAgent = navigator.userAgent.toLowerCase();
      return [2
      /*return*/
      , isWx && /miniProgram/i.test(userAgent)];
    });
  });
};
/**
 * 检测浏览器环境是否为支付宝
 * eg：
 */

export var isAliPay = function isAliPay() {
  var ua = window.navigator.userAgent;
  var reg = /AlipayClient/i;
  return reg.test(ua);
}; // 获取允许平台，同步

export function getRunEnv() {
  var ua = window.navigator.userAgent;
  var isMiniApp = isWXMiniAppBrowser();
  var isIOS = /iPhone|iPad|iPod|iOS/i.test(ua); // 微信小程序

  if (isMiniApp) {
    return 2;
  }

  if (isJoJoBrowser()) {
    if (/JoJoSherlock/gim.test(ua)) {
      // 新识字APP
      return 5;
    }

    if (/huiben/gim.test(ua) || /dev.tinman.anibook/gim.test(ua)) {
      if (isIOS) {
        return 11;
      } // 绘本


      return 6;
    }

    if (/pinyin/gim.test(ua)) {
      // 叫叫拼音app
      return 7;
    }

    if (/sherlock/gim.test(ua)) {
      // 叫叫老识字app
      return 8;
    }

    if (/huihua/gim.test(ua)) {
      // 绘画app
      return 10;
    }

    if (/JoJoCalculate/gim.test(ua)) {
      // 叫叫口算app
      return 4;
    } // JOJOUP跳转


    if (/flawless/gim.test(ua)) {
      return 9;
    } // 叫叫阅读


    if (/read/gim.test(ua)) {
      return 0;
    }
  } // 微信


  if (isWXBrowser()) {
    return 1;
  } // 抖音


  if (/aweme/i.test(ua) || /BytedanceWebview/i.test(ua)) {
    return 21;
  } else if (/NewsArticle/i.test(ua)) {
    // 头条
    return 22;
  } else if (/TTWebView/i.test(ua)) {
    // 字节系列
    return 20;
  } // 其他


  return 3;
} // 获取允许平台，同步

export function getRunEnvText() {
  var env = getRunEnv();
  var envTextMap = {
    1: 'VX_H5',
    2: 'VX_MINI_PROGRAM',
    3: 'OUTSITE',
    4: 'CALCULATE',
    5: 'JOJOSHERLOCK',
    6: 'HUIBEN',
    7: 'PINYIN',
    8: 'SHERLOCK',
    9: 'FLAWLESS',
    0: 'READ',
    10: 'HUIHUA',
    11: 'HUIBEN_IOS'
  };

  if (envTextMap[env]) {
    return envTextMap[env];
  }

  return 'OUTSITE';
}
/**
 * 生成指定范围数字
 * @param min 最小值
 * @param max 最大值
 * @returns 数字
 */

export function randomNumBoth(min, max) {
  if (min === void 0) {
    min = 0;
  }

  if (max === void 0) {
    max = 9;
  }

  var range = max - min;
  var rand = Math.random();
  var num = min + Math.round(rand * range);
  return num;
}
/**
 * 洗牌算法
 * @param arr 数组
 * @returns 整理后的数组
 */

export function getMess(arr) {
  return arr.sort(function () {
    return Math.random() - 0.5;
  });
}
export var joinGroupNicknameAvatarMap = [{
  avatar: '49ee2c67909e4c879093de4a51b76574..jpeg',
  nickname: 'YAN'
}, {
  avatar: '984d4cbcdac944339ff69519fe860b8f..jpg',
  nickname: 'yoyo呀'
}, {
  avatar: '267281b17eff4ab785683a93a912ea2b..jpg',
  nickname: '阿岚'
}, {
  avatar: '2a73fc341db24cfb8ff3480daa196009..jpg',
  nickname: '大智Pick'
}, {
  avatar: 'fb02e97d3b804e66a51d3382e2f4a708..jpg',
  nickname: '蝶恋花'
}, {
  avatar: '0c57f985d6354e5092ae91eb8922ef48..jpg',
  nickname: '服装代理'
}, {
  avatar: '68264160debc43b29dae3374b1e42f5a..jpg',
  nickname: '开心小琪'
}, {
  avatar: '04e2b76ddc2040be9dad60a476e60428..jpg',
  nickname: '墨'
}, {
  avatar: 'fa4e53b6693a4ffaab86ae45fd82d4ec..jpg',
  nickname: '社会王哥'
}, {
  avatar: '22e36cd1d8de4913b944dadb67239091..jpg',
  nickname: '我是静哥'
}, {
  avatar: 'a5a2b8280416499d96418aaeb0071c43..jpg',
  nickname: '小布丁❤'
}, {
  avatar: 'da8b06ac9531466990057942e8393b10..jpg',
  nickname: '小鱼儿与驴'
}, {
  avatar: '76205a80cb274d16be11b96323c2a3c2..jpg',
  nickname: '笑笑又过一天'
}, {
  avatar: '7369187f66fa4e5ab823a2ddb5e40e94..jpg',
  nickname: '阳阳冲鸭'
}, {
  avatar: 'ebf4a11c425c4157b0eba22d2c8e91ee..jpg',
  nickname: '月光宝盒'
}];
var joinGroupMemo = [];
export function getJoinGroup() {
  try {
    if (joinGroupMemo.length) {
      return joinGroupMemo;
    }

    joinGroupMemo = getMess(joinGroupNicknameAvatarMap).slice(0, 5);
    return joinGroupMemo;
  } catch (e) {
    return [];
  }
}
/**
 * 金额转换
 * @param val 金额
 * @param toFixed
 * @returns 转换的金额
 */

export var moneyTransform = function moneyTransform(val, toFixed) {
  if (toFixed === void 0) {
    toFixed = 3;
  }

  if (!val) {
    return 0;
  }

  var nVal = typeof val === 'string' ? parseInt(val, 10) : val;
  var newVal = nVal / 100;

  if (toFixed) {
    return parseFloat(newVal.toFixed(toFixed));
  }

  return newVal;
};
/**
 * 获取平台信息0App 1微信 2小程序 3其他
 * @returns number
 */

export var getCurrPlatform = function getCurrPlatform(report) {
  if (report === void 0) {
    report = false;
  }

  return __awaiter(void 0, void 0, void 0, function () {
    var isMiniApp, _a, e_1;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          _b.trys.push([0, 3,, 4]);

          _a = isWXMiniAppBrowser();
          if (_a) return [3
          /*break*/
          , 2];
          return [4
          /*yield*/
          , getIsMiniProgramEnv()];

        case 1:
          _a = _b.sent();
          _b.label = 2;

        case 2:
          isMiniApp = _a;

          if (isMiniApp) {
            return [2
            /*return*/
            , 2];
          }

          if (isJoJoBrowser()) {
            return [2
            /*return*/
            , report ? 3 : 0];
          }

          if (isWXBrowser()) {
            return [2
            /*return*/
            , 1];
          }

          return [2
          /*return*/
          , report ? 10 : 3];

        case 3:
          e_1 = _b.sent();
          console.log(e_1);
          return [2
          /*return*/
          , report ? 10 : 3];

        case 4:
          return [2
          /*return*/
          ];
      }
    });
  });
};
export var getCurrPlatformText = function getCurrPlatformText() {
  return __awaiter(void 0, void 0, void 0, function () {
    var platform;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , getCurrPlatform()];

        case 1:
          platform = _a.sent();
          return [2
          /*return*/
          , ['APP内', '微信内', '微信小程序', '其他'][platform]];
      }
    });
  });
};
export var qsParse = function qsParse(search) {
  var query = QS.parse((search || window.location.search).replace(/^\?/, '')) || {};
  var newQuery = {};

  for (var _i = 0, _a = Object.entries(query); _i < _a.length; _i++) {
    var _b = _a[_i],
        key = _b[0],
        val = _b[1];

    if (Array.isArray(val)) {
      var firstV = val[0];
      newQuery[key] = firstV;
    } else {
      newQuery[key] = val;
    }
  }

  return newQuery;
};
export var qsStringify = function qsStringify(query) {
  var _query = qsParse();

  var _url = [window.location.origin, window.location.pathname, '?', QS.stringify(__assign(__assign({}, _query), query || {}))].join('');

  return _url;
}; // 获取二级域名

export function getSubDomain() {
  try {
    var subdomain = '';
    var domain = document.domain;
    var domainList = domain.split('.');
    var ipAddressReg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
    /* 若当前域名为 IP 地址、localhost，采用一种特殊的处理
      （只用于我们的测试环境，此部分代码不具有通用性）
       */

    if (ipAddressReg.test(domain) || domain === 'localhost') {
      var level3domain = document.domain;
      var pattern = /^.*?\b\.\b/;
      return level3domain.replace(pattern, '');
    }

    var urlItems = [];
    urlItems.unshift(domainList.pop());

    while (urlItems.length < 2) {
      urlItems.unshift(domainList.pop());
      subdomain = urlItems.join('.');
    }

    return ".".concat(subdomain) || document.domain;
  } catch (e) {
    return document.domain;
  }
}
export function setSubDomainCookies(key, value, options) {
  return Cookie.set(key, value, __assign({
    domain: getSubDomain(),
    path: '/'
  }, options || {}));
}
/**
 * 批量设置子域名 cookie
 * @param data 一个对象，包含多个需要设置的 key-value
 * @param options 其他 cookie 设置选项（可选）
 */

export function setMultipleSubDomainCookies(data, options) {
  Object.entries(data).forEach(function (_a) {
    var key = _a[0],
        value = _a[1];
    setSubDomainCookies(key, value, options);
  });
} // 静态修改url地址

export var changeUrl = function changeUrl(url) {
  try {
    if (typeof window.history.pushState !== 'undefined') {
      var obj = {
        Url: url
      };
      window.history.pushState(obj, document.title, obj.Url);
    }
  } finally {//
  }

  return false;
};
/*
  1 === jojo
  2 === miniprogram
  3 === wxbrowser
*/

export var getEnvEnum = function getEnvEnum() {
  return __awaiter(void 0, void 0, void 0, function () {
    var isInMiniprogram;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (isJoJoBrowser()) {
            return [2
            /*return*/
            , 3];
          }

          return [4
          /*yield*/
          , getIsMiniProgramEnv()];

        case 1:
          isInMiniprogram = _a.sent();

          if (isInMiniprogram) {
            return [2
            /*return*/
            , 2];
          }

          if (isWXBrowser()) {
            return [2
            /*return*/
            , 1];
          }

          return [2
          /*return*/
          , 1];
      }
    });
  });
};
/**
 * 小程序内webview跳转到小程序
 * eg：
 */

export var miniProgramNavigateTo = function miniProgramNavigateTo(_a) {
  var url = _a.url,
      _b = _a.params,
      params = _b === void 0 ? {} : _b,
      type = _a.type;
  var path = Object.keys(params).length > 0 ? "".concat(url, "?").concat(QS.stringify(params)) : url;

  switch (type) {
    case 'redirect':
      window === null || window === void 0 ? void 0 : window.wx.miniProgram.redirectTo({
        url: path
      });
      break;

    case 'tab':
      window === null || window === void 0 ? void 0 : window.wx.miniProgram.switchTab({
        url: path
      });
      break;

    case 'navigate':
      window === null || window === void 0 ? void 0 : window.wx.miniProgram.navigateTo({
        url: path
      });
      break;

    case 'reLaunch':
      window === null || window === void 0 ? void 0 : window.wx.miniProgram.reLaunch({
        url: path
      });
      break;

    default:
      window === null || window === void 0 ? void 0 : window.wx.miniProgram.navigateTo({
        url: path
      });
      break;
  }
};
/**
 * 获取网络状态
 */

export var getNetworkType = function getNetworkType() {
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection || {
    tyep: 'unknown'
  };
  return connection.effectiveType || connection.type;
}; // 匹配连接是否是http/https开头的

export var isHttpLink = function isHttpLink(url) {
  return /^http(s)*/.test(url);
}; // 拼接完整http链接

export var connectLink = function connectLink(url) {
  return isHttpLink(url) ? url : "https:".concat(url);
};
export function ready(func) {
  if (document.readyState !== 'loading') {
    func();
  } else {
    document.addEventListener('DOMContentLoaded', func);
  }
} // 防抖函数

var timeout1 = null;
export function debounce(func, wait) {
  return function (that) {
    if (timeout1) clearTimeout(timeout1);
    timeout1 = setTimeout(function () {
      func.call(that);
    }, wait);
  };
} // 节流

var timeout2 = null;
export function throttle(func, wait) {
  return function (that) {
    if (!timeout2) {
      func.call(that);
      timeout2 = setTimeout(function () {
        timeout2 = null;
      }, wait);
    }
  };
} // 去除空格

export function removeSpace(str) {
  return str.replace(/\s+/g, '');
} // 字符串拼接前缀

export function preJoinStr(str, prefix) {
  try {
    var _str = removeSpace(str);

    var _prefix = prefix || '+';

    if (!_str) {
      return '';
    }

    if (_str.indexOf(_prefix) === 0) {
      return _str;
    }

    return "".concat(_prefix).concat(_str);
  } catch (error) {
    return str;
  }
}
export function canJsonParse(str) {
  try {
    if (Object.prototype.toString.call(str) === '[object String]' && str !== '') {
      return JSON.parse(str);
    }

    return {};
  } catch (_a) {
    return {};
  }
}
export function replaceJoJoUpUrl(openUrl) {
  // 无暇域名进入小程序 域名替换
  var _openUrl = openUrl;

  if (/jojojoy|mohezi/.test(_openUrl) && isJoJoUp) {
    _openUrl = _openUrl.replace(/https:\/\/pages(-dev|-fat|-uat)?\.(jojojoy\.com|mohezi)\.cn(\/mall\/(market|landing))?/, "https://act.tinman.cn/act2/jojoup");
  }

  return _openUrl;
}
export function getPathName(url) {
  if (DEBUG_LOCAL) {
    return "".concat(window.location.origin).concat(url);
  }

  return "".concat(LOCAL_BASE_URL).concat(url);
}
export function localUrlJump(url, replace) {
  if (url === void 0) {
    url = '';
  }

  if (replace === void 0) {
    replace = false;
  }

  var pathname = getPathName(url);

  var _a = qsParse(),
      _b = _a.channel,
      channel = _b === void 0 ? '' : _b,
      channelNo = _a.channelNo; // 跳转没渠道需要写上


  if (channel && url.indexOf('&channel=') < 0) {
    pathname += "&channel=".concat(channel);
  }

  if (channelNo && url.indexOf('&channelNo=') < 0) {
    pathname += "&channelNo=".concat(channelNo);
  }

  if (replace) {
    window.location.replace(pathname);
  } else {
    window.location.href = pathname;
  }
}
export function urlJump(url, replace) {
  if (url === void 0) {
    url = '';
  }

  if (replace === void 0) {
    replace = false;
  }

  var newUrl = url; // JOJOUP路径拼接

  if (isJoJoUp && !/^http/.test(url)) {
    if (url.indexOf('/act2') >= 0) {
      newUrl = url.replace('/act2', ENV_BASE);
    } else {
      newUrl = addTeacherPath + url;
    }
  }

  if (replace) {
    window.location.replace(newUrl);
  } else {
    window.location.href = newUrl;
  }
}
export var isApple = function isApple() {
  var ua = navigator.userAgent; // 判断是否是Mac OS X
  // const isMacOSX = /Mac OS X/.test(ua);
  // 判断是否是iPhone

  var isiPhone = /iPhone/.test(ua); // 判断是否是iPad

  var isiPad = /iPad/.test(ua); // 判断是否是iPod

  var isiPod = /iPod/.test(ua);
  return isiPhone || isiPad || isiPod;
};
export var isAndroid = function isAndroid() {
  var ua = navigator.userAgent;
  var isAd = /Android/.test(ua);
  var isAdr = /Adr/.test(ua);
  return isAd || isAdr;
};
export var isQQBrowser = function isQQBrowser() {
  var ua = navigator.userAgent.toLocaleLowerCase();
  return /mqqbrowser/.test(ua);
}; // 定义一个函数，接受一个字符串参数，返回一个解码后的字符串

export function decodeURIComponentDeep(str) {
  // 如果参数为空或者不是字符串，直接返回参数
  if (!str || typeof str !== 'string') {
    return str;
  } // 定义一个变量，存储上一次解码后的结果


  var prev = ''; // 定义一个变量，存储当前解码后的结果

  var curr = str; // 循环解码，直到结果不再变化或者不包含百分号

  var count = 0;

  while (prev !== curr && curr.includes('%') && count < 3) {
    // 将当前结果赋值给上一次结果
    prev = curr; // 使用decodeURIComponent函数对当前结果进行解码，并赋值给当前结果

    curr = decodeURIComponent(curr);
    count += 1;
  } // 返回最终的解码结果


  return curr;
} // 检查url是否是完整的http链接

export var checkUrl = function checkUrl(url) {
  var uri = url;

  if (!/^(http|https):.*/.test(url)) {
    if (!/^\/\/.*/.test(url)) {
      uri = "https://".concat(url);
    } else {
      uri = "https:".concat(url);
    }
  }

  return uri;
}; // 透传页面参数，临时存储回调地址

export var swimParams = function swimParams(params) {
  var query = qsParse();
  var queryStr = QS.stringify(__assign(__assign({}, query || {}), params || {}));
  sessionStorage.setItem('rurl', "".concat(window.location.origin).concat(addTeacherPath, "/exchange/check?").concat(queryStr));
}; // 客服中心类型

export var ECustomerServiceType;

(function (ECustomerServiceType) {
  /**
   * 确认订单页联系客服参数
   */
  ECustomerServiceType["ORDER"] = "ORDER";
  /**
   * 加老师页联系客服
   */

  ECustomerServiceType["ADDTEACHER"] = "ADDTEACHER";
  /**
   * 激活码兑换
   */

  ECustomerServiceType["ACTIVECODE"] = "ACTIVECODE";
  /**
   * 通用客服中心地址
   */

  ECustomerServiceType["COMMON"] = "COMMON";
})(ECustomerServiceType || (ECustomerServiceType = {})); // 获取不同渠道的客服中心地址


export var getCustomerServiceCenterAddress = function getCustomerServiceCenterAddress(customerServiceChannel) {
  if (customerServiceChannel === void 0) {
    customerServiceChannel = ECustomerServiceType.ORDER;
  }

  var customerServiceData = {
    jojoup: {
      // jojoup 确认订单页客服中心
      ORDER: 'jojoupQR',
      ADDTEACHER: 'jojoupTJ',
      ACTIVECODE: 'jojoupJHM',
      COMMON: ''
    },
    jojo: {
      // jojo 确认订单页客服中心
      ORDER: 'confirmationorder',
      ADDTEACHER: 'addteacher',
      ACTIVECODE: 'activationcode',
      COMMON: ''
    }
  }[isJoJoUp ? 'jojoup' : 'jojo'] || {};
  var serviceChannel = customerServiceData[customerServiceChannel] || '';
  var serviceUrl = "".concat(CUSTOMER_SERVICE_CENTER_ADDRESS).concat(CUSTOMER_SERVICE_CENTER_ADDRESS.includes('?') ? '&' : '?' // 是否已经有参数拼接问号
  , "customerServiceChannel=").concat(serviceChannel); // 统一跳转到客服中转页处理客服跳转逻辑,叫叫app内用新开webview打开

  return getWebviewUrl("".concat(CUSTOMER_TRANSFORM, "?serviceUrl=").concat(encodeURIComponent(serviceUrl), "&fromType=").concat(customerServiceChannel));
}; // 字符串编码

export var btoaString = function btoaString(str) {
  return window.btoa(unescape(encodeURIComponent(str)));
}; // 字符串解码

export var atobString = function atobString(b64) {
  return decodeURIComponent(escape(window.atob(b64)));
};
export var isIOS = function isIOS() {
  var ua = navigator.userAgent;
  var isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  return isiOS;
};
/**
 * 叫叫app内新开webview打开
 * @param targetUrl
 * @returns
 */

export var getWebviewUrl = function getWebviewUrl(targetUrl) {
  if (targetUrl === void 0) {
    targetUrl = '';
  }

  var regHttp = /^https?:\/\//;

  if (regHttp.test(targetUrl) && isJoJoReadBrowser()) {
    return "tinman-router://cn.tinman.jojoread/webview?url=".concat(encodeURIComponent(targetUrl));
  }

  return targetUrl;
};
/**
 * 检测浏览器环境是否是jojo app 包含识字app
 * eg：
 */

export var isJoJoAllBrowser = function isJoJoAllBrowser() {
  var ua = window.navigator.userAgent;
  var reg = /JoJoVersion|JoJoWebViewSymbol/i;
  return reg.test(ua);
};
/**
 * 检测浏览器环境是否是矩阵app
 * eg：
 */

export var isMatrixAppBrowser = function isMatrixAppBrowser() {
  var ua = window.navigator.userAgent;
  var excludeReg = /huihua|sherlock|calculate/gim; // 排除一些JOJOUP

  if (/flawless/.test(ua)) {
    return false;
  }

  if (excludeReg.test(ua)) {
    return true;
  }

  return isJoJoAllBrowser() && !isJoJoReadBrowser();
};
export var getAppVersion = function getAppVersion() {
  try {
    if (isJoJoAllBrowser()) {
      var reg = /jojowebviewsymbol\/([\d.]+)/;
      var ua = window.navigator.userAgent.toLowerCase();
      var result = ua.match(reg);

      if (result) {
        return result[1];
      }
    }
  } catch (_a) {
    return '';
  }

  return '';
};
export function activeInputBlur() {
  try {
    var el = document.activeElement;

    if (el && typeof el.blur === 'function') {
      el.blur();
    }
  } catch (_a) {// 忽略错误
  }
}
/**
 * 获取指定图片的尺寸信息。
 * 该函数会创建一个 Image 对象并加载指定 URL 的图片，
 * 当图片成功加载后，会返回图片的宽度和高度；若加载失败，则抛出错误。
 *
 * @param url - 要获取尺寸信息的图片的 URL。
 * @returns 一个 Promise，成功时解析为包含图片宽度和高度的对象，失败时拒绝并返回错误信息。
 */

export function getImageInfo(url) {
  return new Promise(function (resolve) {
    var image = new Image();

    image.onload = function () {
      resolve({
        width: image.width,
        height: image.height
      });
    };

    image.onerror = function () {
      resolve({});
    };

    image.src = url;
  });
}
export function renderActImgSize(_a) {
  var width = _a.width,
      height = _a.height,
      renderWidth = _a.renderWidth;

  if (width) {
    var actRenderWidth = Math.min(width, renderWidth || window.innerWidth);
    var actRenderHeight = Math.round(actRenderWidth / width * height);
    return {
      width: actRenderWidth,
      height: actRenderHeight
    };
  }

  return {
    width: width,
    height: height
  };
}
export var subjectTexts = {
  1: '思维',
  2: '阅读',
  3: '小作家',
  4: '美育',
  5: '识字',
  6: '英语',
  7: '专题',
  8: '初中语文',
  MATHEMATICS: '思维',
  LANGUAGE: '阅读',
  WRITE: '小作家',
  ART: '美育',
  LITERACY: '识字',
  ENGLISH: '英语',
  SPECIAL: '专题',
  CHINESE: '初中语文'
};
/**
 * 检测是否为纯血鸿蒙（OpenHarmony 内核，HarmonyOS NEXT）
 * @returns {boolean}
 */

export function isPureHarmonyOS() {
  var ua = navigator.userAgent || ''; // 1. 必须包含 OpenHarmony

  var hasOpenHarmony = /OpenHarmony/i.test(ua); // 2. 包含 ArkWeb

  var hasArkWeb = /ArkWeb/i.test(ua); // 3. 解析版本号（HarmonyOS NEXT 从 5.0 起步）

  var versionMatch = ua.match(/OpenHarmony(?:\/|\s)(\d+(?:\.\d+)?)/i);
  var version = 0;

  if (versionMatch && versionMatch[1]) {
    version = parseFloat(versionMatch[1]);
  }

  return hasOpenHarmony && hasArkWeb && version >= 5.0;
}